
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.01","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1397","transform":"translate(-696.849 -442.425)"}},[_c('rect',{attrs:{"data-name":"사각형 1666","width":"14","height":"20","rx":"1","transform":"translate(696.859 442.425)","fill":"#f36628"}}),_c('rect',{attrs:{"data-name":"사각형 1667","width":"3","height":"3","rx":"1","transform":"translate(699.859 445.425)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"사각형 1668","width":"3","height":"3","rx":"1","transform":"translate(704.859 445.425)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"사각형 1669","width":"3","height":"3","rx":"1","transform":"translate(704.859 450.425)","fill":"#fff"}}),_c('path',{attrs:{"data-name":"패스 563","d":"M704.782 455.807a1 1 0 000-.764.989.989 0 00-.217-.326l-4-4a1 1 0 00-1.414 1.414l2.293 2.293h-4.559a14.816 14.816 0 000 2h4.559l-2.293 2.293a1 1 0 101.414 1.414l4-4a1 1 0 00.217-.324z"}})])])
          )
        }
      }
    